module.exports = __webpack_public_path__ + "assets/img/37_1478.b73624ec.jpg";